export default __webpack_public_path__ + "images/7d4863bd8af05f25a750cb321045a48b.png";